import styled from 'styled-components';

export const FirewallStep2 = styled.div`
  padding: 30px 30px 30px 20px;
  background: ${(props) => props.white? 'white': 'transparent'};
  border-top: 4px solid ${(props) => props.theme.primaryDarkColor};
  @media (max-width: 959px) {
    padding: 15px 10px 10px 10px;
  }
  @media (max-width: 375px) {
    padding: 15px 0 10px 0;
  }
`;

export const ActionBadge = styled.span`
  background: ${(props) => (props.type == 'allow' ? '#ecf8e7' : '#fdeaeb')};
  color: ${(props) => (props.type == 'allow' ? '#59c025' : 'red')};
  padding: 4px 8px;
  border-radius: 6px;
  text-transform: capitalize;
`;

export const Card = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 0.5fr 0.8fr 0.8fr 0.5fr;
  width: 100%;
  padding: 12px 16px;
  background: white;
  border-radius: 10px;
  margin-bottom: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  opacity: ${(props) => (props.isDeleted == 1 ? 0.5 : 1)};
  pointer-events: ${(props) => (props.isDeleted == 1 ? 'none' : 'auto')};
  &:hover {
    background: ${(props) =>
      props.isDeleted == 1 ? 'transparent' : props.theme.serverSizeCard.features.hoverBackgroundColor};
  }
`;

export const MobileCard = styled.div`
  margin-top: 15px;
  width: 100%;
  padding: 12px 0;
  background: white;
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  opacity: ${(props) => (props.isDeleted == 1 ? 0.5 : 1)};
  pointer-events: ${(props) => (props.isDeleted == 1 ? 'none' : 'auto')};
  &:hover {
    background: ${(props) =>
      props.isDeleted == 1 ? 'transparent' : props.theme.serverSizeCard.features.hoverBackgroundColor};
  }
`;

export const Headers = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 0.5fr 0.8fr 0.8fr 0.5fr;
  padding: 12px 16px;
  margin-top: 2em;
  p {
    font-weight: bold;
  }
`;

export const Column = styled.div`
  display: flex;
  align-items: center;
  .orange-text {
    color: ${(props) => props.theme.primaryDarkColor} !important;
  }
`;

export const SingleColumn = styled.div`
  display: flex;
  align-items: center;
  padding-right: 10px;
  .text-link {
    text-decoration: underline;
    cursor: pointer;
    color: #007bff;
  }
  p {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const SingleColumnMobile = styled.div`
  .text-link {
    text-decoration: underline;
    cursor: pointer;
    color: #007bff;
  }
  p {
    margin: 0;
  }
`;

export const FlexBetweenColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  flex-wrap: wrap;
`;

export const FlexBetweenColumnBorder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(props) => props.theme.serverSizeCard.borderColor};
  border-top: 1px solid ${(props) => props.theme.serverSizeCard.borderColor};
  padding: 0.6em 16px;
  margin: 0.6em 0;
  flex-wrap: wrap;
`;

export const ListContainers = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileActionBadge = styled.div`
  background: ${(props) => (props.type == 'allow' ? '#ecf8e7' : '#fdeaeb')};
  color: ${(props) => (props.type == 'allow' ? '#59c025' : 'red')};
  padding: 4px 8px;
  border-radius: 6px;
  text-transform: capitalize;
  margin-top: 2px;
`;
